// "Complete your order" add-ons from Shopify product recommendations (the same AI source UpCart uses).
// Falls back to the server-rendered collection cards when recommendations return nothing.
(() => {
  const money = (cents) => (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'}).format(cents / 100);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
  const card = (p) => {
    const v = p.variants.find((x) => x.available) || p.variants[0];
    const single = p.variants.length === 1;
    const img = p.featured_image ? `<img src="${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=300" alt="${esc(p.title)}" loading="lazy">` : '';
    const compare = v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s> ` : '';
    const action = single ? `<button type="button" class="dr-up__add" data-dr-add="${v.id}">Add to cart</button>` : `<a class="dr-up__add" href="${p.url}">Choose options</a>`;
    return `<div class="dr-up__card"><a class="dr-up__img" href="${p.url}">${img}</a><a class="dr-up__title" href="${p.url}">${esc(p.title)}</a><p class="dr-up__price">${compare}<strong>${money(v.price)}</strong></p>${action}</div>`;
  };
  const fill = async (box) => {
    if (box.dataset.drDone) return;
    box.dataset.drDone = '1';
    const id = box.dataset.drRec;
    if (!id) return;
    const exclude = new Set(box.dataset.drExclude.split(',').map(Number));
    const count = Number(box.dataset.drCount) || 6;
    try {
      const url = `${box.dataset.drUrl}.json?product_id=${id}&limit=${count + exclude.size}`;
      const data = await fetch(url).then((r) => r.json());
      const list = (data.products || []).filter((p) => p.available && !exclude.has(p.id)).slice(0, count);
      if (list.length) box.querySelector('.dr-up__track').innerHTML = list.map(card).join('');
    } catch (e) { /* keep fallback cards */ }
    box.hidden = !box.querySelector('.dr-up__card');
  };
  const scan = () => document.querySelectorAll('.dr-up[data-dr-rec]').forEach(fill);
  new MutationObserver(scan).observe(document.documentElement, {childList: true, subtree: true});
  scan();
})();
